module.exports = __webpack_public_path__ + "static/media/no-data.6d00ac6c.svg";